'use strict'
import React, { Component } from 'react'
import ReactDOMServer from 'react-dom/server';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Steps from '../commonComponents/Steps';
import CallAPI from '../commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import { setTableData } from '../../action/index';
import { bindActionCreators } from 'redux';
import ErrorComponent from '../commonComponents/ErrorComponent';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepFour from './StepFour';
import StepThree from './StepThree';
import StepFive from './StepFive';
import { Redirect } from 'react-router-dom';

class DataMerge extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            rawTables: null,
            selectedTable: {
                "transaction":[],
                "master":[]
            },
            stepConfig: [
                {
                    completeStatus: false,
                    title: "Select tables",
                    isSelected:true,
                    stepLevelName:"selectTable"
                },
                {
                    completeStatus: false,
                    title: "Select Columns",
                    isSelected: false,
                    stepLevelName: "selectColumn"
                },
                {
                    completeStatus: false,
                    title: "Append rows",
                    isSelected: false,
                    stepLevelName: "appendTable"
                },
                {
                    completeStatus: false,
                    title: "Merge Columns",
                    isSelected: false,
                    stepLevelName: "mergeTable"
                },
                {
                    completeStatus: false,
                    title: "Execute",
                    isSelected: false,
                    stepLevelName: "execute"

                }
            ],
            stepMapping:{},
            selectedItems:{},
            joinData:[],
            operation:{},
            final_transaction_table:[],
            redirectPath: null,
        }
     
        this.handleSteps = this.handleSteps.bind(this);
        this.handleBackTrack = this.handleBackTrack.bind(this);
        this.generateStepComponent = this.generateStepComponent.bind(this);
        this.handleSelectedTables = this.handleSelectedTables.bind(this);
        // this.fetchTableData = this.fetchTableData.bind(this);
        this.fetchIncludedColumns = this.fetchIncludedColumns.bind(this);
        this.getTableColumns = this.getTableColumns.bind(this);
        this.getIncludedColumns = this.getIncludedColumns.bind(this);
        this.handleAppendTable = this.handleAppendTable.bind(this);
        this.handleMergedTable = this.handleMergedTable.bind(this);
        this.performMerge = this.performMerge.bind(this);
    }

    handleBackTrack(reference){
        this.state.stepConfig[reference.props.stepNo].isSelected = false;
        this.state.stepConfig[reference.props.stepNo].completeStatus = false;
        this.state.stepConfig[reference.props.stepNo - 1].completeStatus = false;
        this.state.stepConfig[reference.props.stepNo - 1].isSelected = true;
        let stepState = this.state.stepConfig;
        this.setState({
            stepConfig: stepState
        })  
    }

    handleSteps(reference){
        this.state.stepConfig[reference.props.stepNo].isSelected = false;
        this.state.stepConfig[reference.props.stepNo].completeStatus = true;
        this.state.stepConfig[reference.props.stepNo + 1].isSelected = true;
        let stepState = this.state.stepConfig;
        this.setState({
            stepConfig: stepState
        })
  
    }

    fetchIncludedColumns(tableArray){
        let final_data = tableArray.map((element,i)=>{
            if (element['includedColumns'] !== null && element['includedColumns'] !== undefined) {
                element['columnConfig'] = element['includedColumns'];
            }
            return element;
        });

        return final_data;
     
    }

    getIncludedColumns(data){


        let current_table = this.state.selectedTable;

        let type = (data[0]['type']).toLowerCase() ;


        let selectedItems = this.state.selectedItems;

        if (selectedItems[data[0]['tableValue']] == null || selectedItems[data[0]['tableValue']] == undefined) {
            selectedItems[data[0]['tableValue']] = data;
        }
        else{
            selectedItems[data[0]['tableValue']] = data;
        }

        if(type == "merge"){
            type = "transaction"
        }
        

        let final_table_index = (current_table[type]).findIndex((element,i)=>{
            return element.value == data[0]['tableValue'];
        });

        current_table[type][final_table_index]['includedColumns'] = data;

        

        this.setState({
            selectedItems: selectedItems,
            selectedTable:current_table
        })
    }


    handleMergedTable(data){
        this.setState({
            operation:data
        })
    }

    generateStepComponent(){
        let stepComponent = null;

        let stepConfig = this.state.stepConfig.filter((element,i)=>{
            return (element.isSelected && !element.completeStatus);
        });

        let key = stepConfig[0].stepLevelName;
        switch (key) {
            case 'selectTable':
                stepComponent = <StepOne stepNo={0} stepData={this} />
                break;
            case 'selectColumn':
                stepComponent = <StepTwo stepNo={1} stepData={this}/>
                break;
            case 'appendTable':
                stepComponent = <StepThree stepNo={2} stepData={this} />
                break;
            case 'mergeTable':
                stepComponent = <StepFour stepNo={3} stepData={this} />
                break;
            case 'execute':
                stepComponent = <StepFive stepNo={4} stepData={this}/>
                break;
            default:
                break;
        }
        return stepComponent;
    }

    handleSelectedTables(data){
        let tableState = this.state.selectedTable;
        tableState[data.type] = this.getTableColumns(data.tableArray);
        this.setState({
            selectedTable:tableState
        });
    }


    getTableColumns(tableArray) {
        // let final_table_columns = [];
        let that = this;
        let tableColumns = tableArray.map((element, i) => {
            let columns_array = JSON.parse(element.information)['default_mapping'];
            let innerArray = {};
            innerArray['name'] = element['name'];
            innerArray['value'] = element['value'];
            innerArray['subtext_value'] = (element['type'].toLowerCase() == "merge") ? "transaction" : element["type"];

            if (element['includedColumns'] !== null && element['includedColumns'] !== undefined){
                innerArray['columnConfig'] = element['includedColumns']; 
            }
            else{
                innerArray['columnConfig'] = Object.values(columns_array).map((innerColumn, i) => {
                    let innerData = {};
                    innerData['name'] = innerColumn;
                    innerData['value'] = innerColumn;
                    innerData['type'] = element['type'];
                    innerData['tableValue'] = element['value'];
                    innerData['subtext_value'] = element['name'];
                    innerData['id'] = `${element['name']}_${innerColumn}`;
                    // innerData['tag_name'] = `${element['name']}.${innerColumn}`;
                    innerData['tag_name'] = `(${element['name']})${innerColumn}`;
                    // innerData['tag_name'] = (<><span>{`${innerColumn}`}</span><sub>{`${element['name']}`}</sub></>);
                    return innerData;
                });
            }            
            return innerArray;
        });

        return tableColumns;
    }

    handleAppendTable(appendData){
        let operation = this.state.operation;
        operation.append = {};
        operation.append.transaction = Object.keys(appendData.mapping);
        operation.append.condition = appendData.mapping;
        this.setState({
            stepMapping:appendData.mapping,
            operation:operation,
            final_transaction_table: appendData.final_table
        })
    }

    performMerge(tableName, innerText, modalName) {
        let that = this;
        let params = {
            siteId: that.props.authData.siteId,
            email: that.props.authData.username
        }

        let operationArray = this.state.operation;
        operationArray.name = tableName;
        operationArray.modal_name = modalName;
        if (operationArray.merge.master.length === 0 && operationArray.merge.transaction.length > 0) {
            delete operationArray.merge.master;
            operationArray.onlyTransaction = true;
        }
        if (innerText === "Save and Execute Later") {
            operationArray.execute = 2;
        } else if (innerText === "Save and Execute") {
            operationArray.execute = 1;
        }
        if (confirm("Please Confirm to Update!")) {
            jQuery("#mergeButton").attr('hidden', true);
            jQuery("#mergeLaterButton").attr('hidden', true);
            jQuery("#loadButton").removeAttr('hidden');
            CallAPI('POST', '/app/v1/mergeTable', that.state.operation, params, 0, function (response) {
                let information = response;
                if (information.status === true) {
                    jQuery("#loadButton").attr('hidden', true);
                    alert(information.information);
                    that.setState({
                        redirectPath: "/adminpanel/v2/savedModel",
                    })
                }
            }, that.props.authData)
        }
    }
   

    render() {
        if (this.state.redirectPath) {
            return <Redirect to={this.state.redirectPath} />
        }
        return (
            <>
                <div className="">
                    <Steps stepArray={this.state.stepConfig} />
                    {this.generateStepComponent()}
                 </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        tableData: state.admin.tableData,
        authData: state.dataSet.authData
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTableData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DataMerge);
// export default DataMerge;

